<template>
  <div class="menu-box animated fadeIn">
    <!-- 导航 -->
    <div>
      <ul
        ref="scrollContainer"
        :class="{ 'fixed-top': isFixed }"
        class="menu-list flexcenter"
      >
        <li
          v-for="(item, index) in navList"
          :key="item.nav_id"
          :class="{ 'active-nav': currentNavIndex == item.nav_id }"
          class="menu-item txt-center"
          @click="handleNavClick(item, index)"
          @mouseenter="showSubMenu(item, index)"
          @mouseleave="hideSubMenu(item, index)"
        >
          {{ item.nav_name }}
        </li>
      </ul>
      <div
        ref="submenuContainer"
        class="submenu"
        :class="{ 'submenu-visible': subNavList.length > 0 }"
        @mouseenter="onSubMenuEnter"
        @mouseleave="onSubMenuLeave"
      >
        <span
          v-for="(subItem, subIndex) in subNavList"
          :key="subItem.nav_id"
          :class="{ 'active-subNav': currentSubnavIndex === subItem.nav_id }"
          class="submenu-item"
          @click="handleSubNavClick(subItem, subIndex)"
        >
          {{ subItem.nav_name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navList: Array,
  },
  data() {
    return {
      // navList: [], // 导航list
      currentNavItem: null, // 当前导航item
      // currentNavIndex: localStorage.getItem("currentNavIndex") || 0, // 当前导航索引
      subNavList: [], // 子导航list
      currentSubnavIndex: localStorage.getItem("childNavIndex") || 0, // 当前子导航索引
      isSubMenuVisible: false, // 子导航是否可见
      originalTop: 0, // 导航原始位置
      isFixed: false, // 导航是否吸顶
    };
  },
  computed: {
    currentNavIndex: {
      get() {
        return this.$store.state.app.currentNavIndex;
      },
      set(val) {
        this.$store.dispatch("SET_CurrentNavIndex", val);
      },
    },
    lang: {
      get() {
        return this.$store.state.app.language;
      },
      set(lang) {
        this.$i18n.locale = lang;
        this.$store.dispatch("setLanguage", lang);
      },
    },
  },
  watch: {
    currentNavIndex(newVal, oldVal) {
      console.log("newVal", newVal);
      console.log("oldVal", oldVal);
      this.currentNavIndex = newVal;
    },
    lang(newVal, oldVal) {
      this.searchInfo.lang = newVal;
      this.searchNewsList();
      this.getNavList();
    },
  },
  created() {},
  mounted() {
    // this.originalTop = this.$refs.scrollContainer.offsetTop;
    // this.$refs.scrollContainer.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // this.$refs.scrollContainer.removeEventListener("scroll", this.handleScroll);
    // localStorage.removeItem("currentNavIndex");
    // localStorage.removeItem("pageQuery");
  },
  watch: {},
  methods: {
    //获取菜单
    async getNavMenu() {
      let params = {
        posid: 1,
        lang: this.lang,
      };
      try {
        const res = await this.$http.fetchGet("/index/getnavs", params);
        if (res.code == 1) {
          localStorage.setItem("navList", JSON.stringify(res.data));
          this.navList = res.data;
        }
      } catch (error) {
        console.error("请求失败:", error);
      }
    },
    //页面滑动是否触发吸顶
    handleScroll() {
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      const threshold = this.originalTop;
      console.log(scrollTop);
      console.log(threshold);
      if (scrollTop >= threshold) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    //菜单切换
    handleNavClick(nav, index) {
      // 处理菜单选择事件
      this.currentNavIndex = nav.nav_id;
      this.$store.dispatch("SET_CurrentNavIndex", this.currentNavIndex);
      // localStorage.setItem("currentNavIndex", this.currentNavIndex);
      //判断nav.link是否包含‘http’
      if (nav.nav_url.includes("http")) {
        window.open(nav.nav_url, "_blank");
        return;
      }
      if (nav.nav_name === "首页") {
        if (this.$route.path !== "/") {
          this.$router.push({
            path: "/",
          });
        }
      } else {
        if (nav.has_children === 1) {
          this.subNavList = nav.children;
          let query = {};
          if (nav.children[0].type_id && nav.children[0].type_id !== "0") {
            query = this.parseParamsString(nav.children[0].type_id);
          }
          console.log(nav.children[0].nav_url)
          // localStorage.setItem("pageQuery", nav.link_params);
          this.$router.push({
            path: nav.children[0].nav_url,
            query: query,
          });
          /* todo:点击有children的一级菜单，默认跳转到children下第一个元素的link */
        } else {
          let query = {};
          if (nav.type_id && nav.type_id !== "0") {
            query = this.parseParamsString(nav.type_id);
          }
          // localStorage.setItem("pageQuery", nav.link_params);
          this.$router.push({
            path: nav.nav_url,
            query: query,
          });
        }
      }
    },
    //子菜单切换
    handleSubNavClick(nav, index) {
      if (this.currentNavItem && this.currentNavItem.has_children === 1) {
        //获取currentNavItem在父级菜单中的索引
        this.currentNavIndex = nav.parent_id;
        this.$store.dispatch("SET_CurrentNavIndex", this.currentNavIndex);
        // localStorage.setItem("currentNavIndex", this.currentNavIndex);
      }

      //子菜单参数缓存
      let query = {};
      if (nav.type_id && nav.type_id !== "0") {
        query = this.parseParamsString(nav.type_id);
      }
      this.currentSubnavIndex = nav.nav_id;
      localStorage.setItem("childNavIndex", nav.nav_id);
      //新增判断：若切换的路由与当前路由一致，则刷新页面（出口页面通用一个页面路由，需要传递参数区分）
      if (
        nav.nav_url === this.$route.path &&
        this.$route.meta.title != nav.nav_name
      ) {
        // 传递新的参数并刷新页面
        this.reloadWithParams(query);
        return;
      }
      // nav.link_params参数形式为 key=value&key=value，处理成key:value对象,
      this.$router.push({
        path: nav.nav_url,
        query: query,
      });
    },
    reloadWithParams(val) {
      // 创建新的路由对象
      const newRoute = {
        path: this.$route.path,
        query: val,
      };
      // 替换当前路由
      this.$router.replace(newRoute);
      // window.location.reload();
    },
    // 显示子菜单
    showSubMenu(item, index) {
      // item.showSubMenu = true;
      this.currentNavItem = item;
      this.isSubMenuVisible = true;
      this.subNavList = item.children;
    },
    // 隐藏子菜单
    hideSubMenu(item, index) {
      // item.showSubMenu = false;
      if (this.isSubMenuVisible) {
        return;
      }
      this.subNavList = [];
      this.currentNavItem = null;
    },
    // 子菜单显示
    onSubMenuEnter() {
      this.isSubMenuVisible = true;
    },
    // 子菜单消失
    onSubMenuLeave() {
      this.isSubMenuVisible = false;
      this.subNavList = [];
    },
    // 解析参数字符串的方法
    parseParamsString(paramsString) {
      if (!paramsString) return {};

      const params = {};
      const paramsArray = paramsString.split(",");

      paramsArray.forEach((param) => {
        const [key, value] = param.split("=");
        params[key] = decodeURIComponent(value);
      });

      return params;
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.menu-box {
  width: 100%;
  height: 5rem;
  // padding: 0 22.5rem;
  background: #1390d8;
  font-size: 1.25rem; //cs20px
  color: #ffffff;
  position: relative;
  // list-style-type: none;
  .menu-list {
    line-height: 5rem;
    height: 5rem;
    position: relative;
    width: 100rem;
    margin: 0 auto;
    .menu-item {
      flex: 1;
      width: 100%;
      cursor: pointer;
      position: relative;
      transition: font-weight 0.1s ease, font-size 0.1s ease;
      font-size: 1.5rem;
      &:hover {
        font-weight: bold;
        font-size: 2rem;
      }
      &.active-nav {
        font-weight: bold;
        font-size: 2rem;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          // transform: translateX(-50%);
          width: 80%;
          height: 0.375rem;
          background: #fff;
          transform: translateX(-50%) scaleX(1);
          transform-origin: left;
          transition: transform 0.2s ease;
        }
      }
    }
  }
  .submenu {
    width: 100%;
    height: 5rem;
    background: #fff;
    position: absolute;
    bottom: -3.9375rem;
    left: 0;
    box-shadow: 0px 3px 10px 1px rgba(92, 113, 159, 0.16);
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.3s ease, opacity 0.3s ease;
    text-align: center;
    line-height: 5rem;
    z-index: 99;
    &.submenu-visible {
      visibility: visible;
      opacity: 1;
      .submenu-item {
        font-size: 1.25rem;
        color: #2a2a2a;
        cursor: pointer;
        margin: 0 1.375rem;
        &:hover {
          color: #0366e8;
        }
        &.active-subNav {
          font-weight: bold;
          color: #0366e8;
        }
      }
    }
  }
}
</style>
